import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css'],
})
export class DeleteModalComponent implements OnInit {
  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {}

  deleteElement(idElement: number) {
    this.ngxSmartModalService.getModal('deleteModal').close();
    this.spinner.show();
    this.sharedService.eventEvent.next(idElement);
  }
}
